// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faculty-Profile {
    margin: 0 auto;
    max-width: 100%;
    font-family: Arial, sans-serif;
    color: black;
  }
 
  
  .faculty-Profile header h1 {
    margin: 0;
    font-size: 2.5rem;
    color: #060505;
  }
  
  .faculty-Profile header h2 {
    margin: 10px 0 0;
    font-size: 1.5rem;
    color: #060505;
  }

  .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: .5rem;
    font-weight: 500;
    line-height: 1.2;
    color: #060505;
}

  .form label {
    width: 44px;
    color: #060505;
}
.form_rows textarea,
.form input,
.form select{
  min-width: 140px;
  flex-grow: 2;
}
.form button{
  max-width: 74px;
  padding: 2px !important;
  font-size: 12px !important;
}
#cbtn{
  padding: 2px;
}
#cfield{
  min-width: 150px !important;
  width: 100%;
}
.add-btn{
  color: #0056b3;
  font-weight: 900;
  background-color: transparent;
}
.faculty-profile_container{
  width: 80%;
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
}
.faculty-Profile{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.form_rows{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5%;
}
  .details-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 30px;
  }
  
  .details-table th,
  .details-table td {
    border: 1px solid #150d0d;
    padding: 10px;
    text-align: left;
  }
  
  .details-table th {
    background-color: #100808;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  .details-table .field-label {
    width: 30%;
    font-weight: bold;
    color: #090707;
  }
  
  .details-table input[type="text"] {
    width: 100%;
    padding: 5px;
    border: 1px solid #070505;
    border-radius: 4px;
  }
  
  .details-table button {
    padding: 5px 10px;
    background-color: #007bff;
    color: #120e0e;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .details-table button:hover {
    background-color: #0056b3;
  }
  
  .image-upload {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .image-upload label {
    font-weight: bold;
    color: #0a0909;
  }
  
  .image-upload input[type="file"] {
    flex: 1 1;
  }
  
  .image-upload button {
    padding: 5px 15px;
    background-color: #28a745;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .image-upload button:hover {
    background-color: #218838;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/facultyprofile.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,YAAY;EACd;;;EAGA;IACE,SAAS;IACT,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;EAEE;IACE,WAAW;IACX,cAAc;AAClB;AACA;;;EAGE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV;;;4BAG0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,OAAO;AACT;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,yBAAyB;IACzB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".faculty-Profile {\r\n    margin: 0 auto;\r\n    max-width: 100%;\r\n    font-family: Arial, sans-serif;\r\n    color: black;\r\n  }\r\n \r\n  \r\n  .faculty-Profile header h1 {\r\n    margin: 0;\r\n    font-size: 2.5rem;\r\n    color: #060505;\r\n  }\r\n  \r\n  .faculty-Profile header h2 {\r\n    margin: 10px 0 0;\r\n    font-size: 1.5rem;\r\n    color: #060505;\r\n  }\r\n\r\n  .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {\r\n    margin-top: 0;\r\n    margin-bottom: .5rem;\r\n    font-weight: 500;\r\n    line-height: 1.2;\r\n    color: #060505;\r\n}\r\n\r\n  .form label {\r\n    width: 44px;\r\n    color: #060505;\r\n}\r\n.form_rows textarea,\r\n.form input,\r\n.form select{\r\n  min-width: 140px;\r\n  flex-grow: 2;\r\n}\r\n.form button{\r\n  max-width: 74px;\r\n  padding: 2px !important;\r\n  font-size: 12px !important;\r\n}\r\n#cbtn{\r\n  padding: 2px;\r\n}\r\n#cfield{\r\n  min-width: 150px !important;\r\n  width: 100%;\r\n}\r\n.add-btn{\r\n  color: #0056b3;\r\n  font-weight: 900;\r\n  background-color: transparent;\r\n}\r\n.faculty-profile_container{\r\n  width: 80%;\r\n  /* display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center; */\r\n}\r\n.faculty-Profile{\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.form_rows{\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 5%;\r\n}\r\n  .details-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .details-table th,\r\n  .details-table td {\r\n    border: 1px solid #150d0d;\r\n    padding: 10px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .details-table th {\r\n    background-color: #100808;\r\n    font-weight: bold;\r\n    text-transform: uppercase;\r\n  }\r\n  \r\n  .details-table .field-label {\r\n    width: 30%;\r\n    font-weight: bold;\r\n    color: #090707;\r\n  }\r\n  \r\n  .details-table input[type=\"text\"] {\r\n    width: 100%;\r\n    padding: 5px;\r\n    border: 1px solid #070505;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .details-table button {\r\n    padding: 5px 10px;\r\n    background-color: #007bff;\r\n    color: #120e0e;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .details-table button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  .image-upload {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .image-upload label {\r\n    font-weight: bold;\r\n    color: #0a0909;\r\n  }\r\n  \r\n  .image-upload input[type=\"file\"] {\r\n    flex: 1;\r\n  }\r\n  \r\n  .image-upload button {\r\n    padding: 5px 15px;\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .image-upload button:hover {\r\n    background-color: #218838;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
